import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Notification } from 'app/services/notification/notification.model';
import { lightSpeedIn, lightSpeedOut } from 'ng-animate';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('animation', [
      transition(':enter', useAnimation(lightSpeedIn, { params: { timing: 0.3 }})),
      transition(':leave', useAnimation(lightSpeedOut, { params: { timing: 0.3 }}))
    ])
  ]
})
export class NotificationComponent implements OnInit, OnDestroy {

  @Input() notification: Notification;
  @Input() playAudioAlerts: boolean;
  @Output() dismiss = new EventEmitter<string>();
  @Output() startRingTone = new EventEmitter();
  @Output() endRingTone = new EventEmitter();

  timeout: any;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.playAudio();
    this.setAutoDismiss();
    this.setNotification();
  }

  ngOnDestroy() {
    this.endRingTone.emit();
    clearTimeout(this.timeout);
    this.clearNotification();
  }

  playAudio() {
    if (this.playAudioAlerts && !['phone', 'callQueue'].includes(this.notification.type)) {
      this.playNotificationAudio();
    } else if (['phone', 'callQueue'].includes(this.notification.type) && this.notification.meta?.connectSoftPhone) {
      this.startRingTone.emit();
    }
  }

  setAutoDismiss() {
    if (this.notification.dismissible) {
      this.timeout = setTimeout(() => {
          this.handleDismiss();
      }, this.notification.dismissDelay ? this.notification.dismissDelay : 15000);
    }
  }

  handleDismiss() {
    this.dismiss.emit(this.notification.id);
  }

  playNotificationAudio() {
    const audio = new Audio();
    audio.src = '../../../assets/notification_simple-02.wav';
    audio.volume = 0.3;
    audio.load();
    audio.play().catch(() => {
      // do nothing if error from playing audio
    });
  }

  setNotification(): void {
    const savedNotifications = this.savedNotifications();
    if (!savedNotifications.length || !savedNotifications.find((n: Notification) => n.id === this.notification.id)) {
      savedNotifications.push(this.notification);
      localStorage.setItem('savedNotifications', JSON.stringify(savedNotifications));
    }
  }

  clearNotification(): void {
    let savedNotifications = this.savedNotifications();
    savedNotifications = savedNotifications.filter((n: Notification) => n.id !== this.notification.id);
    localStorage.setItem('savedNotifications', JSON.stringify(savedNotifications));
  }

  navigateTo(): void {
    if (this.notification.navigationRoute) {
      this.router.navigateByUrl(this.notification.navigationRoute);
      this.handleDismiss();
    } else if (this.notification.borrowerId && this.notification.borrowerId !== -1) {
      this.router.navigateByUrl(`/borrower/${this.notification.borrowerId}`);
    }
  }

  private savedNotifications() {
    return JSON.parse(localStorage.getItem('savedNotifications') || '[]');
  }

}
